import Immutable from 'immutable'

import { getAvailableRecipes } from 'selectors/menu-recipes/getAvailableRecipes'
import { getRecipeIdByCoreId } from 'selectors/menu-recipes/getRecipeIdByCoreId'

const emptyMap = Immutable.Map()

export const getBasketOrderId = (state) => state.basket.get('orderId')
export const isBasketTransactionalOrder = (state) => !getBasketOrderId(state)
export const getBasketRecipes = (state) => state.basket.get('recipes', emptyMap)
export const getBasketRecipePositions = (state) => state.basket.get('recipePositions')
export const getBasketRecipesCount = (state) =>
  state.basket.get('recipes', emptyMap).reduce((sum, recipeQuantity) => sum + recipeQuantity, 0)
export const getNumPortions = (state) => state.basket.get('numPortions')
export const getPromoCode = (state) => state.basket.get('promoCode', false)
export const getPreviewOrderId = (state) => state.basket.get('previewOrderId')
export const getSignupChosenCollection = (state) => state.basket.get('collection')
export const getBasketOrderDetails = (state) => state.basket.get('orderDetails', false)
export const getBasketDate = ({ basket }) => basket.get('date')
export const getBasketSlotId = ({ basket }) => basket.get('slotId')
export const getBasketPostcode = ({ basket }) => basket.get('postcode')
export const getBasketMenuId = ({ basket }) => basket.get('currentMenuId')
export const getBasketMenuUuid = ({ basket }) => basket.get('currentMenuUuid')
export const isFirstRecipeAdded = ({ basket }) => basket.get('hasAddedFirstRecipe')
export const getBasketIsPortionSizeViewVisible = ({ basket }) =>
  basket.get('isPortionSizeViewVisible')
export const getBasketIsShowDetailsViewFirst = ({ basket }) => basket.get('isShowDetailsViewFirst')

export const getBasketProducts = ({ basket }) => basket.get('products')

export const shouldShowBoxSummary = (state) => !getBasketSlotId(state) && !!getBasketPostcode(state)

export const getChosenAddressId = ({ basket }) => basket.getIn(['chosenAddress', 'id'], null)

export const getBasketTariffId = ({ basket }) => basket.get('tariffId')

export const getBasketSaveRequired = ({ basket }) => basket.get('unsaved')

export const getAvailableNumPortions = ({ basket }) =>
  basket.getIn(['availableBoxSize', 'numPortions'])?.toJS()

export const getChosenAddress = (state) => {
  const defaultAddress = state.user
    .get('shippingAddresses')
    ?.filter((address) => address.get('shippingDefault'))
    .first()
  const chosenAddress = state.basket.get('chosenAddress')

  return chosenAddress || defaultAddress
}

export const getBasketUsageCount = (state) => {
  const availableRecipes = getAvailableRecipes(state)

  const basketRecipes = state.basket.get('recipes').toJS()

  let usage = 0

  const basketRecipeCoreIds = Object.keys(basketRecipes)
  basketRecipeCoreIds.forEach((recipeCoreId) => {
    const recipeUUID = getRecipeIdByCoreId(recipeCoreId)(state)

    if (recipeUUID && recipeUUID in availableRecipes) {
      usage += basketRecipes[recipeCoreId]
    }
  })

  return usage
}

export const getSelectedDeliverySlot = (state) => {
  const date = state.basket.get('date')
  const slotId = state.basket.get('slotId')

  if (!date || !slotId) return null

  const slots = state.boxSummaryDeliveryDays.getIn([date, 'slots'], null)
  if (!slots) return null

  const selectedSlot = slots.find((slot) => slot.get('id') === slotId)

  return selectedSlot || null
}

export const getBasketIsFlexOrder = ({ basket }) => basket.get('isFlexOrder', false)

// eslint-disable-next-line import/no-default-export
export default {
  getBasketOrderId,
  getBasketRecipes,
  getBasketUsageCount,
  getNumPortions,
  getPromoCode,
  getSignupChosenCollection,
  getBasketOrderDetails,
  getBasketDate,
  getBasketSlotId,
  getBasketPostcode,
  getBasketProducts,
  getPreviewOrderId,
  getAvailableNumPortions,
  getChosenAddress,
  getBasketIsFlexOrder,
}
